import type { RecentStudyType } from '@mathflat/domain/StudentHome'

export type RecentStudyTabType = '전체' | '숙제' | '학습지' | '교재' | '경시대회' | '반응형평가'

export const recentStudyTypeText: Record<RecentStudyType, string> = {
  HOMEWORK: '숙제',
  WORKSHEET: '학습지',
  WORKBOOK: '교재',
  EXAM: 'KMM수학경시대회',
  CAS: '반응형평가',
  ALL: '전체',
}

export const recentStudyTypeMenuText: Record<RecentStudyType, RecentStudyTabType> = {
  HOMEWORK: '숙제',
  WORKSHEET: '학습지',
  WORKBOOK: '교재',
  EXAM: '경시대회',
  CAS: '반응형평가',
  ALL: '전체',
}
